import type { FunctionalComponent } from 'preact';
import { BRAND_NAME, BUSINESS_HREF, WEBZINE_FOOTER_LINKS } from '@/data/site.ts';

/** 웹진 화면 전용 푸터 (시안 `_index.html` 의 `.wz-footer`) */
export const WebzineFooter: FunctionalComponent = () => (
  <footer class="wz-footer">
    <a href={BUSINESS_HREF} class="wz-footer-logo">
      <img src="/images/logo.png" alt={BRAND_NAME} />
    </a>
    <div class="wz-footer-links">
      {WEBZINE_FOOTER_LINKS.map((link) => (
        <a key={link.href} href={link.href}>
          {link.label}
        </a>
      ))}
    </div>
  </footer>
);
